import type z from "zod"

import type {
  demographicsSchema,
  detailsSchema,
  facilitiesSchema,
  supportServicesSchema,
} from "../sub_forms"

import { createMultiStepFormContext } from "./useMultiStepFormStore"

/**
 * The combined shape of all checkin sub-form schemas.
 * Intersecting the schemas here means the store is typed against
 * validated output — each sub-form owns its own slice of this type.
 */
export type TCheckinForm = z.infer<typeof detailsSchema> &
  z.infer<typeof facilitiesSchema> &
  z.infer<typeof demographicsSchema> &
  z.infer<typeof supportServicesSchema>

export const {
  Provider: CheckinFormProvider,
  useMultiStepForm: useCheckinForm,
  useMultiStepFormSubscribe: useCheckinSubscriber,
} = createMultiStepFormContext<TCheckinForm>()
